/* SlapRack sticker pile hero. Written for SlapRack. Uses Matter.js (MIT), loaded lazily. */
(function () {
  if (customElements.get('sr-sticker-pile')) return;
  var matterPromise = null;
  function loadMatter(src) {
    if (window.Matter) return Promise.resolve(window.Matter);
    if (!matterPromise) {
      matterPromise = new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.src = src; s.async = true;
        s.onload = function () { res(window.Matter); };
        s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    return matterPromise;
  }
  var BREAK = 750;

  class SrStickerPile extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-sticker]')).map(function (el) {
        return {
          src: el.dataset.src, w: +el.dataset.w || 600, h: +el.dataset.h || 600,
          size: +el.dataset.size || 200, mobileSize: +el.dataset.mobileSize || 100,
          hideMobile: el.dataset.hideMobile === 'true'
        };
      });
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reduced || !this.items.length || !this.stage) return; // static pile stays
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !self.started) {
            self.started = true;
            loadMatter(self.dataset.matterSrc).then(function () { self.start(); }).catch(function () {});
          }
          if (self.runner) self.runner.enabled = e.isIntersecting;
        });
      }, { rootMargin: '100px' });
      this.io.observe(this);
    }
    disconnectedCallback() { this.teardown(); if (this.io) this.io.disconnect(); }

    teardown() {
      var M = window.Matter; if (!M || !this.engine) return;
      M.Render.stop(this.render); M.Runner.stop(this.runner);
      M.World.clear(this.engine.world, false); M.Engine.clear(this.engine);
      if (this.render && this.render.canvas) this.render.canvas.remove();
      clearTimeout(this.dropTimer);
      this.engine = null;
    }

    start() {
      var M = window.Matter, self = this;
      this.isMobile = window.innerWidth < BREAK;
      var W = this.stage.clientWidth, H = this.stage.clientHeight;
      var engine = this.engine = M.Engine.create();
      engine.gravity.y = 1.5; engine.timing.timeScale = 0.85;
      var render = this.render = M.Render.create({
        element: this.stage, engine: engine,
        options: { width: W, height: H, wireframes: false, background: 'transparent', pixelRatio: Math.min(window.devicePixelRatio || 1, 2) }
      });
      render.canvas.setAttribute('aria-hidden', 'true');
      render.canvas.className = 'sr-pile__canvas';
      this.buildWalls(W, H);
      M.Render.run(render);
      this.runner = M.Runner.create();
      M.Runner.run(this.runner, engine);
      this.classList.add('is-live');

      // drop stickers in, staggered
      var list = this.items.filter(function (it) { return !(self.isMobile && it.hideMobile); });
      list.sort(function () { return Math.random() - 0.5; });
      var i = 0;
      Promise.all(list.map(function (it) {
        return new Promise(function (res) {
          var im = new Image(); im.onload = function () { it.w = im.naturalWidth || it.w; it.h = im.naturalHeight || it.h; res(); };
          im.onerror = function () { res(); }; im.src = it.src;
        });
      })).then(function () { drop(); });
      function drop() {
        if (!self.engine || i >= list.length) return;
        self.addSticker(list[i++], W);
        self.dropTimer = setTimeout(drop, 140);
      }

      this.bindDrag();
      var lastMobile = this.isMobile, rt;
      this.onResize = function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          var nowMobile = window.innerWidth < BREAK;
          if (nowMobile !== lastMobile) { lastMobile = nowMobile; self.restart(); return; }
          self.resizeStage();
        }, 150);
      };
      window.addEventListener('resize', this.onResize);
    }
    restart() {
      window.removeEventListener('resize', this.onResize);
      this.unbindDrag(); this.teardown(); this.start();
    }
    buildWalls(W, H) {
      var M = window.Matter, t = 200, opts = { isStatic: true, render: { visible: false } };
      if (this.walls) M.Composite.remove(this.engine.world, this.walls);
      this.walls = [
        M.Bodies.rectangle(W / 2, H + t / 2, W * 3, t, opts),
        M.Bodies.rectangle(-t / 2, H / 2 - 2000, t, H * 2 + 4000, opts),
        M.Bodies.rectangle(W + t / 2, H / 2 - 2000, t, H * 2 + 4000, opts)
      ];
      M.Composite.add(this.engine.world, this.walls);
    }
    resizeStage() {
      var M = window.Matter; if (!this.engine) return;
      var W = this.stage.clientWidth, H = this.stage.clientHeight, r = this.render;
      r.options.width = W; r.options.height = H; r.bounds.max.x = W; r.bounds.max.y = H;
      M.Render.setPixelRatio(r, r.options.pixelRatio);
      this.buildWalls(W, H);
      // keep anything that ended up outside back inside
      M.Composite.allBodies(this.engine.world).forEach(function (b) {
        if (!b.isStatic && (b.position.x > W || b.position.x < 0)) M.Body.setPosition(b, { x: W / 2, y: -100 });
      });
    }
    addSticker(it, W) {
      var M = window.Matter;
      var size = this.isMobile ? it.mobileSize : it.size;     // longest side in px
      var scale = size / Math.max(it.w, it.h);
      var bw = it.w * scale, bh = it.h * scale;
      var x = bw / 2 + Math.random() * Math.max(1, W - bw);
      var y = -bh - Math.random() * 300;
      var body = M.Bodies.rectangle(x, y, bw * 0.92, bh * 0.92, {
        chamfer: { radius: Math.min(bw, bh) * 0.3 },
        restitution: 0.3, friction: 0.8, frictionAir: 0.02, angle: (Math.random() - 0.5) * 0.8,
        render: { sprite: { texture: it.src, xScale: scale, yScale: scale } }
      });
      M.Composite.add(this.engine.world, body);
    }
    // Drag/fling without Matter.Mouse so page scroll and wheel keep working.
    pointFrom(e) {
      var r = this.render.canvas.getBoundingClientRect(), p = e.touches ? e.touches[0] : e;
      return { x: p.clientX - r.left, y: p.clientY - r.top };
    }
    bindDrag() {
      var M = window.Matter, self = this, canvas = this.render.canvas, drag = null;
      function bodiesAt(pt) {
        return M.Query.point(M.Composite.allBodies(self.engine.world).filter(function (b) { return !b.isStatic; }), pt);
      }
      function down(e) {
        var pt = self.pointFrom(e), hit = bodiesAt(pt);
        if (!hit.length) return;                 // empty space: let touch scroll
        if (e.cancelable) e.preventDefault();
        var b = hit[hit.length - 1];
        drag = M.Constraint.create({
          pointA: pt, bodyB: b,
          pointB: { x: pt.x - b.position.x, y: pt.y - b.position.y },
          stiffness: 0.2, damping: 0.1, render: { visible: false }
        });
        M.Composite.add(self.engine.world, drag);
        canvas.style.cursor = 'grabbing';
      }
      function move(e) {
        if (!drag) {
          if (!e.touches) canvas.style.cursor = bodiesAt(self.pointFrom(e)).length ? 'grab' : '';
          return;
        }
        if (e.cancelable) e.preventDefault();
        drag.pointA = self.pointFrom(e);
      }
      function up() {
        if (!drag) return;
        M.Composite.remove(self.engine.world, drag); drag = null; canvas.style.cursor = '';
      }
      this._h = { down: down, move: move, up: up };
      canvas.addEventListener('mousedown', down);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', up);
      canvas.addEventListener('touchstart', down, { passive: false });
      canvas.addEventListener('touchmove', move, { passive: false });
      canvas.addEventListener('touchend', up); canvas.addEventListener('touchcancel', up);
    }
    unbindDrag() {
      if (!this._h) return; var h = this._h;
      window.removeEventListener('mousemove', h.move); window.removeEventListener('mouseup', h.up);
    }
  }
  customElements.define('sr-sticker-pile', SrStickerPile);
})();
